"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = void 0;
var react_1 = require("react");
var Analytics_1 = require("../Analytics");
var useAnalytics = function (_a) {
    var analyticsTracker = _a.analyticsTracker, campaign = _a.campaign;
    var _b = react_1.useState(undefined), analytics = _b[0], setAnalytics = _b[1];
    react_1.useEffect(function () {
        if (analyticsTracker) {
            setAnalytics(new Analytics_1.Analytics(campaign, analyticsTracker));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [analyticsTracker]);
    return { analytics: analytics };
};
exports.useAnalytics = useAnalytics;
